import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  studentList: [],
};

export const studentSlice = createSlice({
  name: "student",
  initialState,
  reducers: {
    setStudentList: (state, action) => {
      state.studentList = action.payload;
    },
    removeStudent: (state, action) => {
      state.studentList = state.studentList.filter(
        (student) => student.id !== action.payload
      );
    },
  },
});

export const { setStudentList, removeStudent } = studentSlice.actions;

export default studentSlice.reducer;
